import React, { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

function PasswordInput({
  id,
  placeholder,
  value,
  onChange,
  autoComplete = "current-password",
  required = false,
  className = "",
}) {
  const [visible, setVisible] = useState(false);

  return (
    <div className={`relative w-full ${className}`}>
      <input
        id={id}
        type={visible ? "text" : "password"}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        autoComplete={autoComplete}
        required={required}
        className="w-full rounded-lg border border-greyLight bg-white py-3 pl-5 pr-12 font-josefin text-secondaryText placeholder:text-greyLight outline-none focus:border-primaryDark"
      />
      <button
        type="button"
        onClick={() => setVisible((prev) => !prev)}
        className="absolute right-4 top-1/2 -translate-y-1/2 text-grey p-1"
        aria-label={visible ? "Masquer le mot de passe" : "Afficher le mot de passe"}
      >
        {visible ? <EyeOff size={18} /> : <Eye size={18} />}
      </button>
    </div>
  );
}

export default PasswordInput;
